.demoSuccess {
  --primary-color: #154dd1;
  --primary-border-color: #154dd1;
  --primary-text-color: #fff;
  --primary-hover-color: #193f99;
  --primary-hover-border-color: #193f99;
  --primary-hover-text-color: #fff;
  --primary-background-input-field-color: #e6eff6;
  --primary-placeholder-color: #9fa9bc;
  --primary-border-focus-color: #075da7;
  --primary-cta-color: #e30613;

  --secondary-color: #154dd1;
  --secondary-border-color: #e6eff6;
  --secondary-text-color: #002b4d;
  --secondary-hover-color: #193f99;
  --secondary-hover-border-color: #193f99;
  --secondary-hover-text-color: #fff;

  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  overflow: hidden;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 300;
  text-align: center;
  line-height: 1.56;
}

.demoSuccessCustomRow {
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px !important;
}

div.demoSuccessCustomRow div > h4 {
  color: var(--primary-border-focus-color);
  font-family: "CornerDisplay", sans-serif;
  font-size: 24px;
  font-weight: 500;
}

div.demoSuccessCustomRow h4 > span {
  font-family: "CornerDisplayBolder", sans-serif;
  font-size: 17px;
}

div.demoSuccessTitle h2 {
  font-size: 30px;
  color: var(--primary-border-focus-color);
  font-family: "CornerDisplayBolder", sans-serif;
  text-transform: uppercase;
}

.demoSuccessTitle h2 i {
  font-size: 80px;
  display: block;
  margin-bottom: 24px;
}

div.demoSuccessSubTitle {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--form-text-color);
  font-weight: 300;
  border: 2px solid var(--form-background-box-color);
  border-radius: 25px;
  padding: 8px 16px 8px 16px;
  max-width: clamp(300px, calc(100% - 2rem), 900px);
}

div.demoSuccessSubTitle span {
  word-break: break-word;
}

.demoSuccessLabel {
  min-width: 122px;
  text-align: end;
}

.demoSuccessCredentials {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
}

.demoSuccessClipboardBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 160px;
  height: 40px;
  margin-right: 38px;
  padding: 0 12px;
  background-color: var(--form-background-box-color);
  border-radius: 8px;
  cursor: pointer;
}

.demoSuccessValue {
  color: var(--form-text-title-color);
  font-weight: 500;
}

.demoSuccessTooltip {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0;
}

.demoSuccessTooltip > span {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  position: relative;
  height: 27px;
  width: 83px;
  background-color: #23cd9429;
  color: black;
  padding: 6px 10px 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 300;
  line-height: 15px;
  opacity: 1;
}

.demoSuccessTooltip > span > .customIcon {
  color: green;
  font-size: 18px;
  font-weight: 500;
}

.demoSuccessButton,
.demoSuccessButton:hover,
.demoSuccessButton:focus-visible,
.demoSuccessButton:hover:focus-visible,
.demoSuccessButton:hover:not([disabled]),
.demoSuccessButton:active:not([disabled]) {
  min-width: 222px;
  height: 60px;
  text-transform: uppercase;
  background-color: var(--form-btn-color);
  border: transparent;
  border-radius: 8px;
  color: white;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  outline: none !important;
}

.disclaimer {
  font-size: 14px;
  line-height: 1.33;
  font-weight: 300;
  color: var(--secondary-text-color);
  font-family: "Inter", sans-serif;
}

.disclaimer a {
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline;
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 300;
  font-family: "Inter", sans-serif;
  text-decoration: underline;
  color: var(--secondary-text-color);
}

div.disclaimerRow {
  background-color: var(--form-background-box-color);
  border-radius: 16px;
  padding: 12px 16px;
  margin: 2rem auto 0;
  max-width: clamp(300px, calc(100% - 2rem), 700px);
}

div.disclaimerRow div.mobileDisclaimer h2 {
  margin: 16px 0 !important;
  font-size: 18px;
  color: var(--primary-border-focus-color);
  font-family: "CornerDisplay", sans-serif;
  line-height: 1.2;
  text-transform: none !important;
}

div.disclaimerRow div.mobileDisclaimer h2:nth-child(2) {
  font-size: 30px;
  font-family: "CornerDisplayBolder", sans-serif;
  white-space: nowrap;
}

div.disclaimerRow div.mobileDisclaimer button,
div.disclaimerRow div.mobileDisclaimer button:hover,
div.disclaimerRow div.mobileDisclaimer button:hover:not([disabled]),
div.disclaimerRow div.mobileDisclaimer button:active:not([disabled]) {
  min-width: 222px;
  height: 60px;
  text-transform: uppercase;
  background-color: var(--form-background-box-color);
  font-family: "CornerDisplay", sans-serif;
  color: var(--primary-border-focus-color) !important;
  border: 2px solid var(--primary-border-focus-color);
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 18px;
  letter-spacing: 0.5px;
  cursor: pointer;
}

div.disclaimerRow div.desktopDisclaimer {
  display: flex;
  align-items: center;
}

div.disclaimerRow div.desktopDisclaimer h2 {
  font-size: 20px;
  color: var(--primary-border-focus-color);
  font-family: "CornerDisplay", sans-serif;
  margin: 16px 32px 10px !important;
  text-align: left !important;
  text-transform: none !important;
}

div.disclaimerRow div.desktopDisclaimer h2:nth-child(2) {
  font-size: 30px;
  font-family: "CornerDisplayBolder", sans-serif;
}

div.disclaimerRow div.desktopDisclaimer div h2:nth-child(3) {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 300;
  color: var(--primary-border-focus-color);
  margin: 0;
}

div.disclaimerRow div.desktopDisclaimer img {
  border-radius: 16px;
}

.customButton button {
  font-family: "CornerDisplay", sans-serif;
}

.customButton button.closeButton,
.customButton button.closeButton:hover {
  background-color: transparent !important;
  color: var(--form-btn-color) !important;
  border: none !important;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.33;
  opacity: 1 !important;
  cursor: pointer;
}

.customButton button.closeButton:hover {
  text-decoration: underline !important;
}

@media (max-width: 768px) {
  div.demoSuccessCustomRow div > h4 {
    font-size: 18px;
  }
}
